(function () {
  'use strict';

  function reveal(section) {
    section.classList.add('is-revealed');
  }

  function initSection(section) {
    if (!section || section.nbv2MediaBannerInit) return;
    section.nbv2MediaBannerInit = true;

    if (!section.classList.contains('nbv2-media-banner--animated')) return;

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || typeof IntersectionObserver === 'undefined') {
      reveal(section);
      return;
    }

    var threshold = parseFloat(section.dataset.animationThreshold);
    if (isNaN(threshold) || threshold < 0 || threshold > 1) threshold = 0.4;

    // Watch the artwork, not the section: once stacked on mobile the section is
    // tall enough that its own threshold could pass with the image off screen.
    var stage = section.querySelector('[data-nbv2-media-banner-stage]') || section;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(section);
          observer.unobserve(entry.target);
        });
      },
      { threshold: threshold }
    );

    observer.observe(stage);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nbv2-media-banner]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
